import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { accentuateApiRef, AccentuateClient } from './api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { schemas } from './schemas';
import { rootRouteRef } from './routes';

/** @public */
export const accentuatePlugin = createPlugin({
  id: 'aceituna',
  apis: [
    createApiFactory({
      api: accentuateApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
        catalogApi: catalogApiRef,
      },
      factory({ discoveryApi, fetchApi, identityApi, catalogApi }) {
        return new AccentuateClient({
          discoveryApi,
          fetchApi,
          identityApi,
          catalogApi,
          schemas,
        });
      },
    }),
  ],
});

/**
 * @public
 */
export const AccentuateWrapper = accentuatePlugin.provide(
  createRoutableExtension({
    name: 'AccentuateWrapper',
    component: () =>
      import('./components/EntityLayoutWrapper').then(m => m.EntityLayoutWrapper),
    mountPoint: rootRouteRef,
  }),
);
 